import videoConfig from './config';
import videoConfigDefaults from './configDefaults';
import { extend, forEach, assign, keys, map} from '_';
import Utils from 'medscape/utils';
import $ from 'jquery';

const isLocal = window.medscape.config.env=='localhost';
const ampPath = '/amp-premier/';
const pluginPath = `${ampPath}plugins/`;
const imageServerHost = isLocal ? '//img.staging.medscapestatic.com' : window.medscape.config.staticServer.host;


const ampURL = `${imageServerHost}/pi/core${ampPath}`;
const pluginURL = `${imageServerHost}/pi/core${pluginPath}`;

class Settings{
   constructor(config){
        const videoSettings = config;
        const ccInfo = config.ccInfo;
        const STREAM_CDN_HOST = '//webmd-vh.akamaihd.net';
        const MP4_CDN_HOST = '//webmd-a.akamaihd.net';
        const res = '750k';
        const ccFileRoot = `${imageServerHost}${videoSettings.ccFileRoot.replace(/^en\//, '')}`;
        this.isLocal = isLocal;
        this.ampPath = ampPath;
        this.pluginPath = pluginPath;
        this.imageServerHost = imageServerHost;
        this.ampURL = ampURL;
        this.pluginURL = pluginURL;
        this.vConfig = $.extend(true,videoConfig(pluginURL,ampURL), videoConfigDefaults);
        this.vConfig.autoplay = videoSettings.autoplay;
        //this.vConfig.muted = videoSettings.autoplay ? true : false;
        this.vConfig.muted = videoSettings.muted;
        this.vConfig.media.source = [{
                src: `${STREAM_CDN_HOST}/i/delivery${videoSettings.source}.csmil/master.m3u8`,
                type: 'application/x-mpegURL'
            }, {
                src: `${STREAM_CDN_HOST}/z/delivery${videoSettings.source}.csmil/manifest.f4m`,
                type: 'video/f4m'
            }, {
                src: `${MP4_CDN_HOST}/delivery${videoSettings.source.split(',')[0]}${res}.mp4`,
                type: 'video/mp4'
        }];

        this.vConfig.media.track = map(ccInfo, (path, srcLang) => {
            return {
                kind: 'captions',
                type: 'application/ttml+xml',
                srclang: srcLang.toLowerCase(),
                src: `${ccFileRoot}${path}`
            };
        });

        videoSettings.poster = videoSettings.poster.replace(/^en\//, '');
        videoSettings.poster = Utils.getCompiledHtml(videoSettings.poster);
        this.vConfig.media.poster = videoSettings.poster.startsWith('/build/') || videoSettings.poster.startsWith('http') ? videoSettings.poster : `${imageServerHost}${videoSettings.poster}`;
    }
}

export default Settings;



// WEBPACK FOOTER //
// ./medscape_modules/video/configs/settings.js